import {
  CreateProductConfigurationType,
  ProductConfigurationType,
} from '@client/graphql/types/graphql.ts';

export function formatProductConfigurationType(
  type: ProductConfigurationType | CreateProductConfigurationType
): string {
  switch (type) {
    case ProductConfigurationType.Base:
      return 'Base variation';
    case ProductConfigurationType.Selection:
      return 'Single selection option';
    case ProductConfigurationType.Option:
      return 'Multiple selection option';
    default:
      return 'Unknown';
  }
}
